import React from 'react';

export interface OrganizationLayoutBodyProps {}

export const OrganizationLayoutBody: React.FC<
    { children?: React.ReactNode | undefined } & OrganizationLayoutBodyProps
> = (props) => <>{props.children}</>;
